module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEX///+nxBvIAAAAAXRSTlPFq+juWQAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/template/ie8_opacity_light_75.png
// module id = ../../../../../src/assets/img/template/ie8_opacity_light_75.png
// module chunks = 2